import { render, staticRenderFns } from "./FormSubheader.vue?vue&type=template&id=7db1761e&scoped=true&"
import script from "./FormSubheader.vue?vue&type=script&lang=js&"
export * from "./FormSubheader.vue?vue&type=script&lang=js&"
import style0 from "./FormSubheader.vue?vue&type=style&index=0&id=7db1761e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db1761e",
  null
  
)

export default component.exports